module.exports = __webpack_public_path__ + "img/weiluru.e3874921.png";